import PropTypes from 'prop-types';
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage } from 'react-intl';

import { withRtl } from '../../../components/hoc';
import ScheduleTitle from '../ScheduleTitle';
import ScheduleSubtitle from '../ScheduleSubtitle';
import style from './ScheduleEmpty.scss'; // eslint-disable-line css-modules/no-unused-class

import PieChartIcon from '../../../components/icons/PieChart';

const localMessages = defineMessages({
  emptyScheduleTopText: {
    id: 'schedule.EmptyTopText',
    defaultMessage:
      'Schools with a test, screened, or audition admissions method may only consider your child for an offer if your child completes an assessment.',
    description: 'The empty schedule top text string',
  },
  emptyScheduleBottomText: {
    id: 'schedule.EmptyBottomText',
    defaultMessage: 'Examples: Interviews, tests, portfolios, auditions, etc.',
    description: 'The empty schedule bottom text string',
  },
});

const ScheduleEmpty = ({ user }) => (
  <div className={style.schedule_empty}>
    <ScheduleTitle user={user} />
    <ScheduleSubtitle user={user} />
    <div className={style.scheduleEmptyInfoBox}>
      <div className={style.scheduleEmptyInfoIcon}>
        <PieChartIcon size={144} fill="#80FFD6" ariaLabel="This is a pie chart" />
      </div>
      <div className={style.scheduleEmptyInfoText}>
        <div className={style.scheduleEmptyInfoTextTop}>
          <FormattedMessage {...localMessages.emptyScheduleTopText} />
        </div>
        <div className={style.scheduleEmptyInfoTextBottom}>
          <FormattedMessage {...localMessages.emptyScheduleBottomText} />
        </div>
      </div>
    </div>
  </div>
);

ScheduleEmpty.propTypes = {
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default withRtl(style)(withStyles(style)(ScheduleEmpty));
